function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.425,
  y: 0.425,
  width: 24.028,
  height: 24.028,
  rx: 4.575,
  stroke: "currentColor",
  strokeWidth: 0.85
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.852 6.26562H12.8922L12.8922 14.4967C12.8922 16.6916 11.1284 16.6524 10.9324 16.6524C10.5405 16.6524 9.16862 16.2605 9.16862 14.8886C9.16862 13.164 10.4098 13.0595 11.1284 13.1248V11.1651C5.83729 11.1651 6.22923 18.6122 10.9327 18.6122C14.3819 18.6122 14.656 15.2806 14.656 13.9088V9.79322C14.656 10.4203 16.6158 10.9691 17.5957 11.1651V9.20529C16.0279 9.20529 15.1133 7.24551 14.852 6.26562Z",
  stroke: "currentColor",
  strokeWidth: 0.65
});

var SvgTiktok = function SvgTiktok(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTiktok, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tiktok.1e92bbf2.svg";
export { ForwardRef as ReactComponent };